<template lang="pug">
.edit-area
    slot(name="content")
</template>

<script>
export default {
  name: 'edit-area',
};
</script>

<style lang="scss" scoped>
@import 'src/styles/aiq-variables.scss';

.edit-area {
  height: calc(100vh - 220px);
  overflow-y: auto;
  padding: 32px;
  border: 1px solid $aiq-tab-content-border;
  background-color: $aiq-tab-content-background;
}
</style>